export default __webpack_public_path__ + "static/media/r2.24296ee8.jpg";